export const OfferStates = {
  initial: 'initial',
  inCart: 'inCart',
  warning: 'warning',
  giftReady: 'giftReady',
}